export default function PHP_while() {
  return (
    <div>
      <h1>PHP_while</h1>
    </div>
  );
}
